/**
 * Stable identity for cart lines (client + server) aligned with register merge / Laravel signature.
 * Used to retain optimistic rows while POST /cart/items responses are still catching up.
 */

const normalizeModifiers = (metadata) => {
  const raw = metadata?.modifiers
  if (!Array.isArray(raw)) return []
  return raw
    .map((row) => ({
      modifier_id: Number(row?.modifier_id),
      quantity: Math.max(1, Number(row?.quantity || 1))
    }))
    .filter((m) => Number.isFinite(m.modifier_id))
    .sort((a, b) => a.modifier_id - b.modifier_id)
}

export const stripInternalCartMetadata = (metadata) => {
  const m = { ...(metadata || {}) }
  delete m.__registerCartPendingAdd
  return m
}

export const metadataSignatureForMerge = (metadata) => {
  const m = stripInternalCartMetadata(metadata)
  const discount =
    m.discount && typeof m.discount === 'object'
      ? { type: String(m.discount.type || ''), amount: Number(m.discount.amount || 0) }
      : null

  return JSON.stringify({
    modifiers: normalizeModifiers(m),
    non_taxable: !!m.non_taxable,
    redeeming_for_points: !!m.redeeming_for_points,
    discount,
    notes: String(m.notes || ''),
    ring_by_amount: !!m.ring_by_amount,
    extended_price: m.ring_by_amount && m.extended_price != null
      ? Number(Number(m.extended_price).toFixed(2))
      : null,
    open_price: !!m.open_price,
    convenience_fee_mode: m.convenience_fee_mode === 'apply' || m.convenience_fee_mode === 'exempt'
      ? m.convenience_fee_mode
      : null,
    preset_id: m.preset_id != null ? String(m.preset_id) : null
  })
}

/** Business key: same line config (product + sku barcode identity + modifier/discount signature). */
export const cartLineBusinessKey = (item) => {
  const pid = item.product_id ?? item.metadata?.product_id ?? ''
  const sku = item.sku ?? ''
  return `${pid}\0${sku}\0${metadataSignatureForMerge(item.metadata)}`
}
